$('.js-caseToggleLink').on('click', (e) => {
  const card = $(e.currentTarget).parents('.js-caseToggle')
  const text1 = $(e.currentTarget).data('text-1')
  const text2 = $(e.currentTarget).data('text-2')

  card.toggleClass('is_opened')

  if (card.hasClass('is_opened')) {
    $(e.currentTarget).find('span').text(text2)
  } else {
    $(e.currentTarget).find('span').text(text1)
  }
})
